// import bigDecimal from "js-big-decimal";
// import Web3 from "web3";
const domain = "https://api6.minicorgi.xyz/";
// const bigUnit = new bigDecimal("1000000000000000000");

const Login = async () => {
    const token = localStorage.getItem("token")
    // alert(1)
    try {
        // 
        const checkTelegram = async () => {
            // alert(JSON.stringify(window.Telegram))
            if (window.Telegram && window.Telegram.WebApp) {
                const initDataUnsafe = window.Telegram.WebApp.initDataUnsafe;
                const initData = window.Telegram.WebApp.initData;
                // alert('initData 1', JSON.stringify(initData))
                if (initData) {

                    const res = await fetch(`${domain}auth/login?${initData}`, {
                        method: "GET",
                    }).then((res) => res.json());
                    if (res.code == 200) {
                        localStorage.setItem("token", res.data.token);
                    }

                    return res;
                }
            } else {
                setTimeout(checkTelegram, 100); // Kiểm tra lại sau 100ms nếu window.Telegram chưa sẵn sàng
            }
        };

        return await checkTelegram();

    } catch (err) {
        // alert(JSON.stringify(err))
        return false;
    }
};

const addRef = async (ref) => {
    if (!ref) {
        return;
    }
    const token = localStorage.getItem("token")

    try {
        const res = await fetch(`${domain}user/addRef?refBy=${ref}&token=${token}`, {
            method: "GET",
        }).then((res) => res.json());

        return res;
    } catch (err) {
        return false;
    }
};

const getUser = async () => {
    const token = localStorage.getItem("token")


    try {
        const res = await fetch(`${domain}user?token=${token}`, {
            method: "GET",
        }).then((res) => res.json());

        return res;
    } catch (err) {
        return false;
    }
};

const upgrade = async (id) => {
    const token = localStorage.getItem("token")
    try {
        const res = await fetch(`${domain}mining/upgrade?id=${id}&token=${token}`, {
            method: "GET",
        }).then((res) => res.json());

        return res;
    } catch (err) {
        return false;
    }
};

const claim = async () => {
    const token = localStorage.getItem("token")
    try {
        const res = await fetch(`${domain}mining/claim?token=${token}`, {
            method: "GET",
        }).then((res) => res.json());

        return res;
    } catch (err) {
        return false;
    }
};

const withdtaw = async (address, comment, amount) => {
    const token = localStorage.getItem("token")
    try {
        const res = await fetch(`${domain}user/withdraw?address=${address}&comment=${comment}&amount=${amount}&token=${token}`, {
            method: "GET",
        }).then((res) => res.json());

        return res;
    } catch (err) {
        return false;
    }
};


const formatTimestamp = (date) => {
    const formattedDate = new Date(date);
    const year = formattedDate.getUTCFullYear();
    const month = String(formattedDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(formattedDate.getUTCDate()).padStart(2, '0');
    const hours = String(formattedDate.getUTCHours()).padStart(2, '0');
    const minutes = String(formattedDate.getUTCMinutes()).padStart(2, '0');

    return `${year}.${month}.${day} ${hours}:${minutes}`;
};

function formatNumber(number, decimalPlaces = 2) {
    if (number === null || number === undefined) {
        return number;
    }

    const roundedNumber = Number(Number(number).toFixed(decimalPlaces)).toString();

    const [integerPart, decimalPart] = roundedNumber.split('.');

    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
}

const rateExchange = 1000;

const trups = 4;
const checkPercentMining = (num) => {
    if (num < 100 * rateExchange) {
        return 5 - trups;
    } else if (num < 1000 * rateExchange) {
        return 6 - trups;
    } else if (num < 3000 * rateExchange) {
        return 7 - trups;
    } else if (num < 5000 * rateExchange) {
        return 7 - trups;
    } else if (num < 10000 * rateExchange) {
        return 7 - trups;
    } else {
        return 5 - trups;
    }
}

const checkPercentMiningNo = (num) => {
    if (num < 100 * rateExchange) {
        return 5;
    } else if (num < 1000 * rateExchange) {
        return 6;
    } else if (num < 3000 * rateExchange) {
        return 7;
    } else if (num < 5000 * rateExchange) {
        return 8;
    } else if (num < 10000 * rateExchange) {
        return 9;
    } else {
        return 10;
    }
}


const addressDeposit = 'UQDiMjp2wGsljyc95SbSMymMWfuxbapZKtGRZ3x7RdbbcLFg';

const history = async (type, page) => {

    const token = localStorage.getItem("token")


    // alert(amount)
    try {
        const res = await fetch(`${domain}user/history?type=${type}&page=${page}&token=${token}`, {
            method: "GET",
        }).then((res) => res.json());

        return res;
    } catch (err) {
        return false;
    }
};

const top = async () => {

    const token = localStorage.getItem("token")


    // alert(amount)
    try {
        const res = await fetch(`${domain}user/top?token=${token}`, {
            method: "GET",
        }).then((res) => res.json());

        return res;
    } catch (err) {
        return false;
    }
};

const claimMs = async (ty) => {

    const token = localStorage.getItem("token")


    // alert(amount)
    try {
        const res = await fetch(`${domain}user/mission?type=${ty}&token=${token}`, {
            method: "GET",
        }).then((res) => res.json());

        return res;
    } catch (err) {
        return false;
    }
};

const getBgInInvest = (prie) => {
    console.log(prie);
    if (prie <= 20 * rateExchange) {
        return 'allallss1'
    } else if (prie <= 100 * rateExchange) {
        return 'allallss2'
    } else if (prie <= 300 * rateExchange) {
        return 'allallss3'
    } else if (prie <= 1000 * rateExchange) {
        return 'allallss4'
    } else {
        return 'allallss5'
    }

}

export {
    formatTimestamp, formatNumber, checkPercentMining, upgrade, claim, rateExchange, trups,
    Login, addressDeposit, withdtaw, history, top, getBgInInvest, claimMs, checkPercentMiningNo,
    getUser,
    addRef
}